import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
// import { useNavigate } from "react-router-dom";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import WorkflowApproveReject from "../../../../Components/Workflow/WorkflowApproveReject";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import RequestInfoModal from "../../../../Components/Modal/supplier_app/Sourcing/RequestInfoModal";
import {
  getpurchaseGroup1,
  getCostCenterOptions,
  getGLAccountOptions,
  getPriorityOptions,
  getBusinessUnitOptions,
  getDeliveryAddressOptions,
} from "./PRConstant";
import { formatDate } from "../../../../common/Validations";

const PurchaseRequisitionDetailedPage = () => {
  const divRef = useRef(null);
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Purchase Requisition");

  let prNumber = useSelector(
    (state) => state?.sourcing?.purchase_requisition?.prNumber,
  ); // User Details from Store

  let workflow = useSelector(
    (state) => state?.sourcing?.purchase_requisition?.workflowPR,
  ); // workflowPO from Store

  let getConstantVar = useSelector((state) => state?.common?.data); // User getConstantVar from Store

  let userDataRoles = useSelector((state) => state?.user?.data?.roles); // User Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [getHeaderData, setHeaderData] = useState(false);
  const adminEmail =
    getHeaderData?.workflowActionLogs?.[0]?.approveresInfo?.[0]?.email || "";
  const adminFirstName =
    getHeaderData?.workflowActionLogs?.[0]?.approveresInfo?.[0]?.firstName ||
    "";
  const isWorkflowCompleted = getHeaderData?.workflowActionLogs?.some(
    (log) =>
      log.stepType === "Completion_Task" && log.currentAction === "Completed",
  );
  // const [totalRows, setTotalRows] = useState(10);
  // const [perPage, setPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getViewHeaderText, setViewHeaderText] = useState(false);

  // Request Info Modal
  const [requestInfoModalShow, setRequestInfoModalShow] = useState(false);
  const [replyTarget, setReplyTarget] = useState(null);

  // eslint-disable-next-line
  const [edit, setEdit] = useState(true); // true = view mode, false = edit mode
  const [disabled, setDisabled] = useState(true);
  const [getDropdownData, setDropdownData] = useState("");

  // Edit mode state
  const [isEditMode, setIsEditMode] = useState(false);
  const [editLineItems, setEditLineItems] = useState([]);
  const [originalHeaderData, setOriginalHeaderData] = useState(null);
  const [originalLineItems, setOriginalLineItems] = useState([]);
  // Track the snapshot of formInputs at edit start for diff
  const [originalFormInputs, setOriginalFormInputs] = useState({});

  // Master data from API
  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getcurrency, setcurrency] = useState([]);
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  const [getPurchaseType, setPurchaseType] = useState([]);
  const [getPurchaseCategory, setPurchaseCategory] = useState([]);

  // Edit form state
  const [formInputs, setFormInputs] = useState({});

  const currentDate = new Date();
  const userRole = userDataRoles?.[0]?.roleId || "";
  const allowedRoles = ["BUYER", "ADMIN"];
  const isAllowedRole = allowedRoles.includes(userRole);

  const currentformattedDate = `${String(currentDate.getDate()).padStart(2, "0")}-${String(currentDate.getMonth() + 1).padStart(2, "0")}-${currentDate.getFullYear()}`;
  const handleRequestInfoSubmit = async (message) => {
    const today = new Date();
    const dateStr = `${String(today.getDate()).padStart(2, "0")}-${String(today.getMonth() + 1).padStart(2, "0")}-${today.getFullYear()}`;

    const existingEntries = getHeaderData?.requestForInformation || [];

    const uniqueId = Date.now().toString();
    const version = `V${existingEntries.length}`;
    const newEntry = {
      id: uniqueId,
      version,
      date: dateStr,
      replayDate: "",
      procMngr:
        userRole === "PROC-MNGR" || userRole === "PROC-SNR-MNGR" ? message : "",
      buyer: userRole === "buyer" || userRole === "admin" ? message : "",
    };
    const payloadEntries = [...existingEntries, newEntry];

    const toastId = toast.loading("Submitting...", {
      position: "top-right",
    });

    try {
      const res = await ItemService.updatePR({
        data: {
          documentNumber: getHeaderData?.purchaseReqDocumentNr,
          requestForInformation: payloadEntries,
        },
      });

      if (res?.status === 200) {
        toast.success("Request Info submitted successfully", {
          duration: 3000,
          position: "top-right",
        });
        setRequestInfoModalShow(false);
        loadInitialPageData();
        const mailMessage = {
          documentNumber: getHeaderData?.purchaseReqDocumentNr,
          rfiComments: message,
          approverName: userData?.firstName,
          requesterName: adminFirstName,
          date: currentformattedDate,
          adminName: adminFirstName,
          email: adminEmail,
        };
        ItemService.sendRFIRaisedEmail(mailMessage);
      } else {
        toast.error(res?.message || "Failed to submit", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Something went wrong", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  const handleReplySubmit = async (message) => {
    const existingEntries = getHeaderData?.requestForInformation || [];
    const targetEntry = existingEntries.find((e) => e.id === replyTarget?.id);
    if (!targetEntry) return;

    const today = new Date();
    const dateStr = `${String(today.getDate()).padStart(2, "0")}-${String(today.getMonth() + 1).padStart(2, "0")}-${today.getFullYear()}`;

    const updatedEntries = existingEntries.map((entry) =>
      entry.id === replyTarget?.id
        ? { ...entry, replayDate: dateStr, buyer: message }
        : entry,
    );

    const toastId = toast.loading("Submitting...", {
      position: "top-right",
    });

    try {
      const res = await ItemService.updatePR({
        data: {
          documentNumber: getHeaderData?.purchaseReqDocumentNr,
          requestForInformation: updatedEntries,
        },
      });

      if (res?.status === 200) {
        toast.success("Reply submitted successfully", {
          duration: 3000,
          position: "top-right",
        });
        setRequestInfoModalShow(false);
        setReplyTarget(null);
        loadInitialPageData();
        const pendingLog = getHeaderData?.workflowActionLogs?.find(
          (log) => log.currentAction === "Pending",
        );
        const pendingApprover = pendingLog?.approveresInfo?.[0];

        const mailsendmessgefromProc = {
          documentNumber: getHeaderData?.purchaseReqDocumentNr,
          message,
          email: pendingApprover?.email || "",
          adminName: adminFirstName,
          approverName: pendingApprover?.firstName || "",
          requesterName: adminFirstName,
          responseDate: dateStr,
        };
        ItemService.sendRFIResponseEmail({ data: mailsendmessgefromProc });
      } else {
        toast.error(res?.message || "Failed to submit", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Something went wrong", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  const handleReplyClick = (row) => {
    setReplyTarget(row);
    setRequestInfoModalShow(true);
  };
  // eslint-disable-next-line
  const handleDeleteEntry = async (row) => {
    const entries = getHeaderData?.requestForInformation || [];
    const updatedEntries = entries.filter(
      (entry) =>
        entry.version !== row.version ||
        entry.date !== row.date ||
        entry.procMngr !== row.procMngr ||
        entry.buyer !== row.buyer,
    );

    const toastId = toast.loading("Deleting...", { position: "top-right" });

    try {
      const res = await ItemService.updatePR({
        data: {
          documentNumber: getHeaderData?.purchaseReqDocumentNr,
          requestForInformation: updatedEntries,
        },
      });

      if (res?.status === 200) {
        toast.success("Entry deleted", {
          duration: 3000,
          position: "top-right",
        });
        loadInitialPageData();
      } else {
        toast.error(res?.message || "Failed to delete", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Something went wrong", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  //Service Items
  let serviceColInfo = [
    {
      name: "Service Line Nr",
      cell: (row) => <span>{row.serviceLineNr} </span>,
      width: "180px",
    },
    {
      name: "Service Number",
      cell: (row) => <span>{row.serviceNr} </span>,
      width: "180px",
    },
    {
      name: "Service Desc",
      cell: (row) => <span>{row.serviceDescription} </span>,
      width: "180px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "180px",
    },
    {
      name: "Service Quantity",
      cell: (row) => <span>{row.serviceQuantity} </span>,
      width: "180px",
    },
    {
      name: "Unit Value",
      cell: (row) => <span>{row.unitValue} </span>,
      width: "180px",
    },
    {
      name: "Gross Value",
      cell: (row) => <span>{row.grossValue} </span>,
      width: "180px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "180px",
    },
  ];

  const [getItemNr, setItemNr] = useState("");
  const [getServiceData, setServiceData] = useState([]);
  const [getServiceTableStatus, setServiceTableStatus] = useState(false);

  useEffect(() => {
    if (divRef.current) {
      try {
        // eslint-disable-next-line no-unused-vars
        const styles = window.getComputedStyle(divRef.current);
      } catch (error) {
        console.error("Failed to get computed style:", error);
      }
    }
  }, [getServiceTableStatus]);

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const loadInitialPageData = async () => {
    setLoading(true);
    if (prNumber) {
      let obj = {
        documentNumber: prNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getPRDetail(obj).then((item) => {
        if (item?.status === 200) {
          setHeaderData(item?.data);
          setFormInputs(item?.data);
          setData(item?.data?.items);
          // Store original data for backup
          setOriginalHeaderData(item?.data);
          setOriginalLineItems(item?.data?.items || []);
          setEditLineItems(item?.data?.items ? [...item?.data?.items] : []);
          // Store original form inputs (without _id) for diff
          const { _id, ...inputsCopy } = item?.data || {};
          setOriginalFormInputs(inputsCopy);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      setLoading(false);
    } else {
      window.history.back();
    }
  };

  const getMasterDataFunc = async () => {
    try {
      const [
        purchaseOrgRes,
        companyCodeRes,
        incoTermsRes,
        currencyRes,
        paymentTermRes,
        purchaseTypeRes,
        purchaseCategoryRes,
      ] = await Promise.allSettled([
        ItemService.getMasterData({ codeType: "purchaseOrganisation" }),
        ItemService.getMasterData({ codeType: "companyCode" }),
        ItemService.getMasterData({ codeType: "INCOTerms" }),
        ItemService.getMasterData({ codeType: "currency" }),
        ItemService.getMasterData({ codeType: "paymentTerm" }),
        ItemService.getMasterData({ codeType: "PrPurchaseType" }),
        ItemService.getMasterData({ codeType: "PurchaseCategory" }),
      ]);

      if (
        purchaseOrgRes.status === "fulfilled" &&
        purchaseOrgRes.value?.status === 200
      ) {
        setPurchaseOrg(purchaseOrgRes.value.data);
      }

      if (
        companyCodeRes.status === "fulfilled" &&
        companyCodeRes.value?.status === 200
      ) {
        setCompanyCode(companyCodeRes.value.data);
      }

      if (
        incoTermsRes.status === "fulfilled" &&
        incoTermsRes.value?.status === 200
      ) {
        setINCOTerms(incoTermsRes.value.data);
      }

      if (
        currencyRes.status === "fulfilled" &&
        currencyRes.value?.status === 200
      ) {
        setcurrency(currencyRes.value.data);
      }

      if (
        paymentTermRes.status === "fulfilled" &&
        paymentTermRes.value?.status === 200
      ) {
        setpaymentTerm(paymentTermRes.value.data);
      }

      if (
        purchaseTypeRes.status === "fulfilled" &&
        purchaseTypeRes.value?.status === 200
      ) {
        setPurchaseType(purchaseTypeRes.value.data);
      }

      if (
        purchaseCategoryRes.status === "fulfilled" &&
        purchaseCategoryRes.value?.status === 200
      ) {
        setPurchaseCategory(purchaseCategoryRes.value.data);
      }
    } catch (error) {
      console.error("Unexpected error in getMasterDataFunc:", error);
    }
  };

  useEffect(() => {
    loadInitialPageData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prNumber]);

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  // Safe numeric parser — returns 0 for null/undefined/empty/NaN
  const safeNum = (v) => {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  };

  // Line item edit handler
  const handleLineItemChange = (index, field, value) => {
    setEditLineItems((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item)),
    );
  };

  // Recompute header totals whenever line items change in edit mode
  useEffect(() => {
    if (!isEditMode) return;

    let itemTotal = 0;
    let taxTotal = 0;

    editLineItems.forEach((item) => {
      const qty = safeNum(item.purchaseQuantity);
      const price = safeNum(item.orderPriceUnit);
      const itemValue = qty * price;
      const taxPct = safeNum(item.taxCode);

      itemTotal += itemValue;
      taxTotal += (itemValue * taxPct) / 100;
    });

    const totals = {
      purchasingDocumentTaxTotalValue: taxTotal,
      purchasingDocumentItemTotalValue: itemTotal,
      purchasingReqDocumentValue: itemTotal + taxTotal,
    };

    setHeaderData((prev) => ({ ...prev, ...totals }));
    setFormInputs((prev) => ({ ...prev, ...totals }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editLineItems, isEditMode]);

  const columnsMAT = [
    {
      name: "PR ItemNr",
      selector: (row) => row.purchasingReqDocumentItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length || 0} </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.prStatusItem} />
        </>
      ),
      width: "180px",
    },
    {
      name: "Material/Service Code",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "185px",
    },
    {
      name: "Material Desc",
      selector: (row) => row.materialDescription,
      width: "180px",
      wrap: true,
    },
    {
      name: "Quantity",
      cell: (row) => {
        const displayValue =
          row.quotationDocument?.[0]?.awardQty != null
            ? row.quotationDocument[0].awardQty
            : (row.purchaseQuantity ?? "--");
        if (isEditMode) {
          const itemIndex = editLineItems.indexOf(row);
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={row.purchaseQuantity ?? ""}
              onChange={(e) =>
                handleLineItemChange(
                  itemIndex,
                  "purchaseQuantity",
                  e.target.value,
                )
              }
            />
          );
        }
        return <span>{displayValue}</span>;
      },
      sortable: true,
      width: "110px",
    },
    {
      name: "UOM",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "100px",
    },
    {
      name: "Unit Price",
      cell: (row) => {
        const displayValue =
          row?.quotationDocument?.[0]?.quotationUnitPrice != null
            ? row.quotationDocument[0].quotationUnitPrice
            : (row.orderPriceUnit ?? "--");
        if (isEditMode) {
          const itemIndex = editLineItems.indexOf(row);
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={row.orderPriceUnit ?? ""}
              onChange={(e) =>
                handleLineItemChange(
                  itemIndex,
                  "orderPriceUnit",
                  e.target.value,
                )
              }
            />
          );
        }
        return <span>{displayValue}</span>;
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "Item Value",
      cell: (row) => {
        const displayValue =
          row?.quotationDocument?.[0]?.awardValue != null
            ? row.quotationDocument[0].awardValue
            : (row.netValue ?? "--");
        const computedValue =
          safeNum(row.purchaseQuantity) * safeNum(row.orderPriceUnit);
        if (isEditMode) {
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={computedValue || ""}
              disabled
            />
          );
        }
        return (
          <span>
            {displayValue != null ? displayValue : computedValue || "--"}
          </span>
        );
      },
      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Tax Amount",
      cell: (row) => {
        const itemValue =
          safeNum(row.purchaseQuantity) * safeNum(row.orderPriceUnit);
        const taxPct = safeNum(row.taxCode);
        const computedTax = (itemValue * taxPct) / 100;
        if (isEditMode) {
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={computedTax}
              disabled
            />
          );
        }
        return <span>{computedTax || 0}</span>;
      },
      sortable: true,
      width: "125px",
    },
    {
      name: "Tax %",
      cell: (row) => {
        if (isEditMode) {
          const itemIndex = editLineItems.indexOf(row);
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={row.taxCode ?? ""}
              onChange={(e) =>
                handleLineItemChange(itemIndex, "taxCode", e.target.value)
              }
            />
          );
        }
        return <span>{safeNum(row.taxCode)}</span>;
      },
      sortable: true,
      width: "100px",
    },
    {
      name: "Specification",
      cell: (row) => {
        if (isEditMode) {
          const itemIndex = editLineItems.indexOf(row);
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={row.specification ?? ""}
              onChange={(e) =>
                handleLineItemChange(itemIndex, "specification", e.target.value)
              }
            />
          );
        }
        return <span>{row.specification || "--"}</span>;
      },
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      name: "Category",
      selector: (row) => row.materialGroup,
      sortable: true,
      width: "200px",
    },
    {
      name: "Sub-Category",
      selector: (row) => row.subCategory || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      cell: (row) => {
        if (isEditMode) {
          const itemIndex = editLineItems.indexOf(row);
          return (
            <input
              type="date"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={row.deliveryDate ?? ""}
              onChange={(e) =>
                handleLineItemChange(itemIndex, "deliveryDate", e.target.value)
              }
            />
          );
        }
        return <span>{row.deliveryDate}</span>;
      },
      sortable: true,
      width: "140px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "",
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Preferred Vendor",
      selector: (row) => row.preferedVendor || "--",
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: "Suggested Vendor",
      selector: (row) => row.suggestedVendor || "--",
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: "Last Supplier",
      selector: (row) => row.lastSupplierName || "--",
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: "Last Purchase Rate",
      selector: (row) => row.lastPurchaseRate || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Attachment",
      selector: (row) => row.attachmentId || "--",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center pe-2">
            {(row.attachmentId && (
              <img
                src="assets/img/newIcons/attached-file.png"
                className="mt-1 attachmentIcon"
                alt="attachments"
                onClick={() => handleViewFile(row.attachmentId)}
              />
            )) ||
              "--"}
          </div>
        </div>
      ),
      width: "350px",
    },
    {
      name: "User Department",
      selector: (row) => row.userDepartment,
      sortable: true,
      width: "200px",
    },
    {
      name: "Procurement Category",
      selector: (row) => row.procurementCategory,
      sortable: true,
      width: "200px",
    },
    {
      name: "Procurement Team",
      selector: (row) => row.procurementTeam,
      sortable: true,
      width: "200px",
    },
    {
      name: "Requisitioner",
      selector: (row) => row.nameOfRequisitioner,
      sortable: true,
      width: "200px",
    },
  ];

  const columnsSER = [
    {
      name: "PR ItemNr",
      selector: (row) => row.purchasingReqDocumentItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length || 0} </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Service",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServiceItemTable(
                row.services,
                row.purchasingReqDocumentItemNr,
              )
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.prStatusItem} />
        </>
      ),
      width: "180px",
    },
    {
      name: "Material/Service Code",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "185px",
    },
    {
      name: "Material Desc",
      selector: (row) => row.materialDescription,
      width: "180px",
      wrap: true,
    },
    {
      name: "Quantity",
      cell: (row) => {
        if (isEditMode) {
          const itemIndex = editLineItems.indexOf(row);
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={row.purchaseQuantity ?? ""}
              onChange={(e) =>
                handleLineItemChange(
                  itemIndex,
                  "purchaseQuantity",
                  e.target.value,
                )
              }
            />
          );
        }
        return <span>{row.purchaseQuantity ?? "--"}</span>;
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "UOM",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Price",
      cell: (row) => {
        if (isEditMode) {
          const itemIndex = editLineItems.indexOf(row);
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={row.orderPriceUnit ?? ""}
              onChange={(e) =>
                handleLineItemChange(
                  itemIndex,
                  "orderPriceUnit",
                  e.target.value,
                )
              }
            />
          );
        }
        return <span>{row.orderPriceUnit || "--"}</span>;
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "Net Value",
      cell: (row) => {
        const computedValue =
          safeNum(row.purchaseQuantity) * safeNum(row.orderPriceUnit);
        if (isEditMode) {
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={computedValue || ""}
              disabled
            />
          );
        }
        return <span>{computedValue || "--"}</span>;
      },
      sortable: true,
      width: "200px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Tax Amount",
      cell: (row) => {
        const itemValue =
          safeNum(row.purchaseQuantity) * safeNum(row.orderPriceUnit);
        const taxPct = safeNum(row.taxCode);
        const computedTax = (itemValue * taxPct) / 100;
        if (isEditMode) {
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={computedTax}
              disabled
            />
          );
        }
        return <span>{computedTax || 0}</span>;
      },
      sortable: true,
      width: "125px",
    },
    {
      name: "Tax %",
      cell: (row) => {
        if (isEditMode) {
          const itemIndex = editLineItems.indexOf(row);
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={row.taxCode ?? ""}
              onChange={(e) =>
                handleLineItemChange(itemIndex, "taxCode", e.target.value)
              }
            />
          );
        }
        return <span>{safeNum(row.taxCode)}</span>;
      },
      sortable: true,
      width: "100px",
    },
    {
      name: "Specification",
      cell: (row) => {
        if (isEditMode) {
          const itemIndex = editLineItems.indexOf(row);
          return (
            <input
              type="text"
              className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-maroon-600"
              value={row.specification ?? ""}
              onChange={(e) =>
                handleLineItemChange(itemIndex, "specification", e.target.value)
              }
            />
          );
        }
        return <span>{row.specification || "--"}</span>;
      },
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      name: "Category",
      selector: (row) => row.materialGroup,
      sortable: true,
      width: "200px",
    },
    {
      name: "Sub-Category",
      selector: (row) => row.subCategory || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "",
      sortable: true,
      width: "200px",
    },
    {
      name: "Preferred Vendor",
      selector: (row) => row.preferedVendor || "--",
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: "Suggested Vendor",
      selector: (row) => row.suggestedVendor || "--",
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: "Last Supplier",
      selector: (row) => row.lastSupplierName || "--",
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: "Last Purchase Rate",
      selector: (row) => row.lastPurchaseRate || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "User Department",
      selector: (row) => row.userDepartment,
      sortable: true,
      width: "200px",
    },
    {
      name: "Procurement Category",
      selector: (row) => row.procurementCategory,
      sortable: true,
      width: "200px",
    },
    {
      name: "procurement Team",
      selector: (row) => row.procurementTeam,
      sortable: true,
      width: "200px",
    },
    {
      name: "Requisitioner",
      selector: (row) => row.nameOfRequisitioner,
      sortable: true,
      width: "200px",
    },
    {
      name: "Attachment",
      selector: (row) => row.attachmentId || "--",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center pe-2">
            {(row.attachmentId && (
              <img
                src="assets/img/newIcons/attached-file.png"
                className="mt-1 attachmentIcon"
                alt="attachments"
                onClick={() => handleViewFile(row.attachmentId)}
              />
            )) ||
              "--"}
          </div>
        </div>
      ),
      width: "350px",
    },
  ];

  const headerItemColInfo = [
    {
      name: "Header Text Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Header Text",
      cell: (row) => <span>{row.prItemNr} </span>,
      width: "250px",
    },
  ];

  const lineItemColInfo = [
    {
      name: "Item Text Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Item Text",
      cell: (row) => <span>{row.prItemNr} </span>,
      width: "250px",
    },
  ];

  // OnClick on Header Text  Data
  const headerTextShowModal = (headerTextData) => {
    setItemLevelData(headerTextData);
    setItemLevelColumns(headerItemColInfo);
    setModalTitle("Header Text Details");
    setViewHeaderText(true);
  };
  const headerTextHideModal = () => {
    setViewHeaderText(false);
  };

  // Workflow

  useEffect(() => {
    if (
      workflow?.workflow_record?.businessComponentId ===
      getConstantVar?.POBusinessComponentId
    ) {
      localStorage.setItem("menu", workflow?.page);
      localStorage.setItem("submenu", "-");
    } else {
      if (getHeaderData.purchaseTypeCode === "MAT") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Purchase Order");
      } else if (getHeaderData.purchaseTypeCode === "SA") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Scheduling Agreement");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showServiceItemTable = (serviceData, itemNr) => {
    setItemNr(itemNr);
    setServiceData(serviceData);
    setServiceTableStatus(true);
  };
  const hide = () => {
    setServiceTableStatus(false);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((prev) => ({ ...prev, [name]: value }));
  };

  // eslint-disable-next-line
  const handleEdit = async () => {
    setEdit(false);
    setDisabled(false);
    setIsEditMode(true);
    // Store original data for cancel and diff
    setOriginalHeaderData(getHeaderData);
    setOriginalLineItems([...data]);
    setEditLineItems(data ? [...data] : []);
    // Take a deep-ish snapshot of formInputs (exclude internal fields like _id)
    const { _id, ...inputsCopy } = formInputs;
    setOriginalFormInputs(inputsCopy);
    await getMasterDataFunc();
  };

  // eslint-disable-next-line
  const handleCancel = () => {
    // Restore original data
    setHeaderData(originalHeaderData);
    setData(originalLineItems);
    setFormInputs(originalHeaderData);
    setEditLineItems(originalLineItems ? [...originalLineItems] : []);

    // Reset edit mode states
    setEdit(true);
    setDisabled(true);
    setIsEditMode(false);
  };

  // Helper: compute the diff of header fields changed from original
  const getChangedHeaderFields = () => {
    const { _id, ...currentInputs } = formInputs;
    const changed = {};
    Object.keys(currentInputs).forEach((key) => {
      if (
        JSON.stringify(currentInputs[key]) !==
        JSON.stringify(originalFormInputs[key])
      ) {
        changed[key] = currentInputs[key];
      }
    });
    return changed;
  };

  // Helper: compute changed line items - send ALL items if any field in any item changed
  const getChangedLineItems = () => {
    if (!originalLineItems || !originalLineItems.length) {
      // If no original, return all current items
      return editLineItems;
    }
    // Check if ANY item has changed - if so, send ALL items
    const hasAnyChange = editLineItems.some((item, index) => {
      const originalItem = originalLineItems[index];
      if (!originalItem) return true; // New item
      // Check if any field has changed
      return Object.keys(item).some(
        (key) =>
          JSON.stringify(item[key]) !== JSON.stringify(originalItem[key]),
      );
    });

    // If any item changed, send all items; otherwise send empty array
    return hasAnyChange ? editLineItems : [];
  };

  // eslint-disable-next-line
  const handleUpdate = async () => {
    const toastId = toast.loading("Updating Purchase Requisition...", {
      position: "top-right",
    });
    try {
      // Compute only the changed header fields
      const changedHeader = getChangedHeaderFields();

      // Compute changed line items - only include if there are changes
      const changedLineItems = getChangedLineItems();

      // Build payload with only changed header fields
      // Only include items array if there are changed items
      const obj = {
        data: {
          documentNumber: getHeaderData?.purchaseReqDocumentNr,
          ...changedHeader,
          ...(changedLineItems.length > 0 ? { items: changedLineItems } : {}),
        },
      };

      const res = await ItemService.updatePRDetails(obj);

      if (res?.status === 200) {
        toast.success("PR updated successfully", {
          duration: 3000,
          position: "top-right",
        });
        setEdit(true);
        setDisabled(true);
        setIsEditMode(false);

        // Refresh full PR data from backend after successful update
        await loadInitialPageData();
      } else {
        toast.error(res?.message || "Update failed", {
          duration: 4000,
          position: "top-right",
        });
        setDisabled(false);
      }
    } catch (error) {
      console.error("handleUpdate error:", error);
      toast.error(error?.message || "Something went wrong", {
        duration: 4000,
        position: "top-right",
      });
      setDisabled(false);
    } finally {
      toast.dismiss(toastId);
    }
  };

  useEffect(() => {
    if (!getDropdownData?.textField) return;
    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData.textField]: getDropdownData.name,
      [getDropdownData.textCode]: getDropdownData.code,
    }));
  }, [getDropdownData]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Purchase Requisition Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {getHeaderData.purchaseReqDocumentNr}
              </span>
              <span>
                {getHeaderData?.prStatusHeader === "PR Approved" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.prStatusHeader}
                  </span>
                ) : getHeaderData?.prStatusHeader === "In Release" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {getHeaderData?.prStatusHeader}
                  </span>
                ) : getHeaderData?.prStatusHeader === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.prStatusHeader}
                  </span>
                ) : getHeaderData?.prStatusHeader === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.prStatusHeader}
                  </span>
                ) : (
                  getHeaderData?.prStatusHeader
                )}
              </span>
            </h2>
            <p className="subText">Purchase Requisition Information </p>
            <hr />

            {/* Workflow Component */}
            <Row>
              <Col md={isAllowedRole ? 8 : 10} lg={isAllowedRole ? 8 : 10}>
                <WorkflowApproveReject workflowData={workflow} />
              </Col>
              {!isWorkflowCompleted && allowedRoles.includes(userRole) && (
                <Col
                  md={4}
                  lg={4}
                  className="d-flex align-items-start justify-content-end"
                >
                  {!isWorkflowCompleted && (
                    <>
                      {edit ? (
                        <>
                          <button
                            className="btnCommon btn d-none"
                            disabled={disabled}
                          >
                            update
                          </button>
                          <button
                            className="btnCommon btn d-none"
                            disabled={disabled}
                          >
                            cancel
                          </button>
                          <button
                            className="btnCommon btn"
                            onClick={handleEdit}
                          >
                            Edit
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="btnCommon btn d-none"
                            onClick={handleEdit}
                          >
                            Edit
                          </button>
                          <button
                            className="btnCommon btn"
                            onClick={handleUpdate}
                            disabled={disabled}
                          >
                            update
                          </button>
                          <button
                            className="btnCommon btn"
                            onClick={handleCancel}
                          >
                            cancel
                          </button>
                        </>
                      )}
                    </>
                  )}
                </Col>
              )}
              {/* <Col md={1} lg={2}>
                {userDataRoles?.[0]?.roleId === ("PROC-MNGR" || "PROC-SNR-MNGR") && (
                  <>
                    {workflow?.workflow_record?.workflowActionLogs?.length >
                    0 ? (
                      workflow?.workflow_record?.workflowActionLogs?.some(
                        (log) =>
                          log.workflowStatus !== "Closed" ||
                          (log.stepType === "Completion_Task" &&
                            log.currentAction !== "Completed"),
                      ) ? (
                        <button
                          className="btnCommon btn"
                          onClick={() => setRequestInfoModalShow(true)}
                        >
                          Request Info
                        </button>
                      ) : null
                    ) : (
                      <button
                        className="btnCommon btn"
                        onClick={() => setRequestInfoModalShow(true)}
                      >
                        Request Info
                      </button>
                    )}
                  </>
                )}
              </Col> */}
              <Col md={2} lg={2}>
                {userDataRoles?.some(
                  (role) =>
                    role.roleId === "PROC-MNGR" ||
                    role.roleId === "PROC-SNR-MNGR",
                ) && (
                  <>
                    {workflow?.workflow_record?.workflowActionLogs?.length >
                    0 ? (
                      workflow?.workflow_record?.workflowActionLogs?.some(
                        (log) =>
                          log.workflowStatus !== "Closed" ||
                          (log.stepType === "Completion_Task" &&
                            log.currentAction !== "Completed"),
                      ) ? (
                        <button
                          className="btnCommon btn"
                          onClick={() => setRequestInfoModalShow(true)}
                        >
                          Request Info
                        </button>
                      ) : null
                    ) : (
                      <button
                        className="btnCommon btn"
                        onClick={() => setRequestInfoModalShow(true)}
                      >
                        Request Info
                      </button>
                    )}
                  </>
                )}
              </Col>
              {/* {edit ? (
                <Col
                  xs={12}
                  md={2}
                  lg={2}
                  className="d-flex justify-content-end align-items-center"
                >
                  <button className="btn btn-primary" onClick={handleEdit}>
                    <i className="bi bi-pencil-square px-2"></i>Edit
                  </button>
                </Col>
              ) : (
                <Col
                  xs={12}
                  md={2}
                  lg={2}
                  className="d-flex justify-content-end align-items-center gap-2"
                >
                  <button
                    className="btn btn-primary"
                    onClick={handleUpdate}
                    disabled={disabled}
                  >
                    <i className="bi bi-arrow-repeat px-2"></i>Update
                  </button>
                  <button className="btn btn-danger" onClick={handleCancel}>
                    <i className="bi bi-x-circle px-2"></i>Cancel
                  </button>
                </Col>
              )} */}
            </Row>

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HR</span>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                      <span className="headerTitle">Header Details</span>
                      <span className="subHeaderTitle"> </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Document Type"
                          id="purchasingReqDocumentType"
                          name="purchasingReqDocumentType"
                          value={getHeaderData?.purchasingReqDocumentType || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="PR Number"
                          name="purchaseReqDocumentNr"
                          id="purchaseReqDocumentNr"
                          value={getHeaderData?.purchaseReqDocumentNr || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="version"
                          name="version"
                          id="version"
                          value={getHeaderData?.version || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Requested On"
                          id="createdAt"
                          name="createdAt"
                          // placeholder=""
                          // value={getHeaderData?.createdAt || ""}
                          value={getHeaderData?.createdAt?formatDate(getHeaderData.createdAt):""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Requested By"
                          id="initiatorName"
                          name="initiatorName"
                          // placeholder=""
                          value={getHeaderData?.initiatorName || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status"
                          id="prStatusHeader"
                          name="prStatusHeader"
                          // placeholder=""
                          value={getHeaderData?.prStatusHeader || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="Purchase Type"
                          id="purchaseType"
                          name="purchaseType"
                          // placeholder=""
                          value={getHeaderData?.purchaseType || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        /> */}
                        <ComboboxField
                          id="purchaseType"
                          label="Purchase Type"
                          placeholder=""
                          data={getPurchaseType}
                          iconClassName="dropdownIcon"
                          name="purchaseType"
                          code="purchaseTypeCode"
                          setValue={formInputs?.purchaseType || []}
                          getvalue={setDropdownData}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="Company"
                          id="companyCode"
                          name="companyCode"
                          // placeholder=""
                          value={getHeaderData?.companyCode || ""}
                          onChange={onInputChange}
                          disabled={disabled}
                        /> */}
                        <ComboboxField
                          label="Company Code"
                          extraLabel="SAP Company Code"
                          placeholder=""
                          data={getCompanyCode}
                          id="companyCode"
                          iconClassName="dropdownIcon"
                          name="companyCode"
                          code="companyCodeCode"
                          setValue={formInputs?.companyCode || ""}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Business Unit"
                          name="businessUnit"
                          code="businessUnitCode"
                          placeholder=""
                          data={getBusinessUnitOptions}
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.businessUnit || ""}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="Purchasing Org"
                          id="purchasingOrg"
                          name="purchasingOrg"
                          // placeholder=""
                          value={getHeaderData?.purchasingOrg || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        /> */}
                        <ComboboxField
                          label="Purchase Organization"
                          placeholder=""
                          data={getPurchaseOrg}
                          id="purchasingOrg"
                          iconClassName="dropdownIcon"
                          name="purchasingOrg"
                          code="purchasingOrgCode"
                          setValue={formInputs?.purchasingOrg || []}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="Purchasing Group"
                          id="purchasingGroup"
                          name="purchasingGroup"
                          // placeholder=""
                          value={getHeaderData?.purchasingGroup || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        /> */}
                        <ComboboxField
                          label="Purchase Group"
                          name="purchasingGroup"
                          // data={getpurchaseGroup}
                          data={getpurchaseGroup1}
                          id="purchasingGroup"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.purchasingGroup || []}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Purchase Category"
                          name="purchaseCategory"
                          code="purchaseCategoryCode"
                          placeholder=""
                          data={getPurchaseCategory}
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.purchaseCategory || ""}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="Payment Terms"
                          id="paymentTerms"
                          name="paymentTerms"
                          // placeholder=""
                          value={getHeaderData?.paymentTerms || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        /> */}
                        <ComboboxField
                          label="Payment Terms"
                          name="paymentTerms"
                          code="paymentTermsCode"
                          data={getpaymentTerm}
                          setValue={formInputs?.paymentTerms || ""}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="Inco Terms"
                          id="incoTerms"
                          name="incoTerms"
                          // placeholder=""
                          value={getHeaderData?.incoTerms || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        /> */}
                        <ComboboxField
                          label="INCOTerms"
                          extraLabel="INCOTerms Code"
                          placeholder=""
                          data={getINCOTerms}
                          id="incoTerms"
                          iconClassName="dropdownIcon"
                          name="incoTerms"
                          code="incoTermsCode"
                          setValue={formInputs?.incoTerms || ""}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="IncoTerms Location"
                          id="incoTermsLocation"
                          name="incoTermsLocation"
                          // placeholder=""
                          value={formInputs?.incoTermsLocation || ""}
                          onChange={onInputChange}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="Currency"
                          id="currencyCode"
                          name="currencyCode"
                          value={formInputs?.currencyCode || ""}
                          disabled={true}
                        /> */}
                        <ComboboxField
                          label="Currency"
                          placeholder=""
                          data={getcurrency}
                          id="currency"
                          iconClassName="dropdownIcon"
                          name="currency"
                          code="currencyCode"
                          setValue={
                            formInputs?.currency ||
                            formInputs?.currencyCode ||
                            ""
                          }
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Cost Center"
                          name="costCenter"
                          code="costCenterCode"
                          placeholder=""
                          data={getCostCenterOptions}
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.costCenter || ""}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Priority"
                          name="priority"
                          code="priorityCode"
                          placeholder=""
                          data={getPriorityOptions}
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.priority || ""}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Total Tax Amount"
                          id="totalTaxAmount"
                          name="purchasingDocumentTaxTotalValue"
                          value={
                            getHeaderData?.purchasingDocumentTaxTotalValue || ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Item Total Amount"
                          id="itemTotalAmount"
                          name="purchasingDocumentItemTotalValue"
                          value={
                            getHeaderData?.purchasingDocumentItemTotalValue ||
                            ""
                          }
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchasing Req Value"
                          id="purchasingReqDocumentValue"
                          name="purchasingReqDocumentValue"
                          // placeholder=""
                          value={
                            getHeaderData?.purchasingReqDocumentValue || ""
                          }
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="GL Account"
                          name="glAccount"
                          code="glAccountCode"
                          placeholder=""
                          data={getGLAccountOptions}
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.glAccount || ""}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Delivery Address"
                          name="deliveryAddress"
                          placeholder=""
                          data={getDeliveryAddressOptions}
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.deliveryAddress || ""}
                          getvalue={setDropdownData}
                          disabled={disabled}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Purchasing Req Remark"
                          id="purchasingReqRemark"
                          name="purchasingReqRemark"
                          // placeholder=""
                          value={formInputs?.purchasingReqRemark || ""}
                          onChange={onInputChange}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Business Justification"
                          id="businessJustification"
                          name="businessJustification"
                          value={formInputs?.businessJustification || ""}
                          onChange={onInputChange}
                          disabled={disabled}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div className="form-check mt-4 ms-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="budgetAvailability"
                            name="budgetAvailability"
                            checked={formInputs?.budgetAvailability === "Yes"}
                            disabled={disabled}
                            onChange={(e) => {
                              setFormInputs((prev) => ({
                                ...prev,
                                budgetAvailability: e.target.checked
                                  ? "Yes"
                                  : "No",
                              }));
                            }}
                            style={{
                              cursor: "not-allowed",
                              width: "20px",
                              height: "20px",
                            }}
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="budgetAvailability"
                            style={{ fontWeight: "500", marginTop: "2px" }}
                          >
                            Budget Available
                          </label>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding mt-4 pt-3"
                      >
                        <div>
                          <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                            Header Text
                          </label>
                          <span
                            style={{ marginLeft: "15px" }}
                            onClick={() =>
                              headerTextShowModal(getHeaderData?.headerTextData)
                            }
                          >
                            <i className="bi bi-calendar2-week iconTable"></i>
                          </span>
                          <span className="suppliersIcon">
                            {" "}
                            {getHeaderData?.headerTextData?.length || 0}{" "}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                      <span className="headerTitle">Line Items</span>
                      <span className="subHeaderTitle"> </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {getServiceTableStatus && (
                        <Col xs={2} md={2} lg={2} className="">
                          <button
                            className="btnTable btn-danger"
                            onClick={hide}
                          >
                            <i className="bi bi-eye-slash-fill"></i> Hide
                            Serivces
                          </button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={
                            getHeaderData?.purchaseTypeCode === "SER"
                              ? columnsSER
                              : columnsMAT
                          }
                          data={isEditMode ? editLineItems : data}
                          progressPending={loading}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Itemss */}
            {getServiceTableStatus && (
              <div
                ref={divRef}
                className="accordion mb-4"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">LI</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">
                          {getHeaderData.purchaseTypeCode === "SER"
                            ? `Services - PR Item: ${getItemNr}`
                            : ""}
                        </span>
                        <span className="subHeaderTitle"> </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={
                              getHeaderData.purchaseTypeCode === "SER"
                                ? serviceColInfo
                                : ""
                            }
                            data={getServiceData}
                            progressPending={loading}
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            // onSelectedRowsChange={handleChange}
                            // clearSelectedRows={toggleCleared}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Request For Information */}
            {getHeaderData?.requestForInformation?.length > 0 && (
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i className="bi bi-info-circle"></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RI</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">
                          Request For Information
                        </span>
                        <span className="subHeaderTitle"> </span>
                      </Col>
                    </Row>
                  </h2>

                  <div>
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={[
                              {
                                name: "Version",
                                selector: (row) => row.version,
                                sortable: true,
                              },
                              {
                                name: "Date",
                                selector: (row) => row.date,
                                sortable: true,
                              },
                              {
                                name: "Reply Date",
                                selector: (row) => row.replayDate || "-",
                                sortable: true,
                              },
                              {
                                name: "Proc Manager",
                                selector: (row) => row.procMngr || "-",
                              },
                              {
                                name: "Buyer",
                                selector: (row) => row.buyer || "-",
                              },
                              ...(userDataRoles?.some(
                                (role) =>
                                  role.roleId === "PROC-MNGR" ||
                                  role.roleId === "PROC-SNR-MNGR",
                              )
                                ? []
                                : [
                                    {
                                      name: "Action",
                                      cell: (row) => (
                                        <div className="d-flex flex-row gap-1">
                                          <button
                                            className="btn btn-primary text-nowrap flex-shrink-0"
                                            onClick={() =>
                                              handleReplyClick(row)
                                            }
                                            disabled={isWorkflowCompleted}
                                            // onClick={() => handleReplySubmit (row)}
                                          >
                                            <i className="bi bi-reply"></i>{" "}
                                            Reply
                                          </button>
                                        </div>
                                      ),
                                      ignoreRowClick: true,
                                      allowOverflow: true,
                                      button: true,
                                    },
                                  ]),
                            ]}
                            data={getHeaderData?.requestForInformation || []}
                            pagination
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Header Text  */}
      <CommonItemLevelDatatableModal
        show={getViewHeaderText}
        onHide={() => headerTextHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      <RequestInfoModal
        show={requestInfoModalShow}
        onHide={() => {
          setRequestInfoModalShow(false);
          setReplyTarget(null);
        }}
        onSubmit={replyTarget ? handleReplySubmit : handleRequestInfoSubmit}
      />
    </main>
  );
};

export default PurchaseRequisitionDetailedPage;
